/* eslint-disable import-extensions/file-extension-required */
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import fetchMentionsProviderDataQuery, {
	type fetchMentionsProviderDataQuery$data,
	type fetchMentionsProviderDataQuery$variables,
} from './__generated__/fetchMentionsProviderDataQuery.graphql';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadMentionsProvider = async (): Promise<{
	data: fetchMentionsProviderDataQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> =>
	query<fetchMentionsProviderDataQuery$data, fetchMentionsProviderDataQuery$variables>({
		query: fetchMentionsProviderDataQuery,
	});
